function Validator() {
    this.standard = function(waybill) {
        // house
        // number
        // consignee_name
        // 暂停做前端，之後需要補上
        // if (!waybill.number) {
        //     return "運單號異常"
        // }
        // if (!waybill.sub_waybill_number) {
        //     return "子號異常"
        // }
        // if (!waybill.consignee_name) {
        //     return "收件人異常"
        // }
        // if (!waybill.consignee_address) {
        //     return "收件人地址異常"
        // }
        return true
    }
}

module.exports = Validator
